<div class="c-content c-content--wrapper"
		 [ngClass]="{'c-content--xxl': !vm.loading && !vm.preVisitTickets?.length, 'u-no-p@up-to-md': vm.loading || vm.preVisitTickets?.length}"
		 [ngStyle]="vm.loading && {'min-height': '300px'}">
	<section class="c-section u-no-pb" *ngIf="vm.preVisitTickets?.length">
		<div *ngIf="!vm.loading">
			<div>
				<div class="c-content c-content--border-bottom u-no-pt u-no-ph@md-and-up u-hidden@up-to-md">
					<div class="o-grid o-grid--wrap ">
						<div class="o-grid__cell o-grid__cell--w-15 u-no-p">
							<p class="c-text c-text--gray">{{'PreVisit.User_Tickets.Created' | translate}}</p>
						</div>
						<div class="o-grid__cell o-grid__cell--w-25 u-no-p">
							<p class="c-text c-text--gray">{{'PreVisit.User_Tickets.Type' | translate}}</p>
						</div>
						<div class="o-grid__cell o-grid__cell--w-15 u-no-p">
							<p class="c-text c-text--gray">{{'PreVisit.User_Tickets.Status' | translate}}</p>
						</div>
						<div class="o-grid__cell o-grid__cell--w-25 u-no-p">
                            <p class="c-text c-text--gray">{{'PreVisit.User_Tickets.Patient' | translate}}</p>
                        </div>
						<div class="o-grid__cell o-grid__cell--w-10 c-text--right u-no-p"></div>
					</div>
				</div>
				<ul class="c-list">
					<li *ngFor="let preVisitTicket of vm.preVisitTickets | startFrom:vm.currentPage*vm.pageSize | arrayLimitTo:vm.pageSize ; let $index=index">
						<div class="c-content c-content--border-bottom u-no-ph@md-and-up">
							<div class="o-grid o-grid--wrap@up-to-md u-ost-sm@md-and-up" style="min-height:22px;align-items: center;">
								<div class="o-grid__cell o-grid__cell--w-fit o-grid__cell--w-100 o-grid__cell--w-15@md-and-up u-no-p">
									<p class="o-grid c-text c-text--sm@up-to-sm">
										<span class="u-hidden@md-and-up">{{ 'PreVisit.User_Tickets.Created' | translate }}: </span>
										<span class="o-grid__cell--right@up-to-md">{{ preVisitTicket.created | date: 'dd.MM.yyyy HH:mm' }}</span>
									</p>
								</div>
								<div class="o-grid__cell o-grid__cell--w-fit o-grid__cell--w-100 o-grid__cell--w-25@md-and-up u-no-p">
									<p class="o-grid c-text c-text--sm@up-to-sm">
										<span class="u-hidden@md-and-up">{{ 'PreVisit.User_Tickets.Type' | translate }}: </span>
										<span id="ticketType{{preVisitTicket.id}}" class="o-grid__cell--right@up-to-md">{{vm.enumTranslations[preVisitTicket.type]}}</span>
									</p>
								</div>
								<div class="o-grid__cell o-grid__cell--w-fit o-grid__cell--w-100 o-grid__cell--w-15@md-and-up u-no-p">
									<p class="o-grid c-text c-text--sm@up-to-sm">
										<span class="u-hidden@md-and-up">{{ 'PreVisit.User_Tickets.Status' | translate }}: </span>
										<span id="ticketStatus{{preVisitTicket.id}}" class="o-grid__cell--right@up-to-md">{{ vm.enumTranslations[preVisitTicket.status] }}</span>
									</p>
								</div>
								<div class="o-grid__cell o-grid__cell--w-fit o-grid__cell--w-100 o-grid__cell--w-25@md-and-up u-no-p">
                                    <p class="o-grid c-text c-text--sm@up-to-sm">
                                        <span class="u-hidden@md-and-up">{{ 'PreVisit.User_Tickets.Patient' | translate }}: </span>
                                        <span class="o-grid__cell--right@up-to-md">{{preVisitTicket.patient.firstname}} {{preVisitTicket.patient.lastname}} 
                                        (<span [ngStyle]="preVisitTicket.patient.email.endsWith('eesti.ee') && {'color': 'red'}">{{preVisitTicket.patient.email}}</span>)
                                        </span>
                                    </p>
                                </div>
								
								<div class="o-grid__cell u-no-p">
									<div class="o-grid">
										<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-fixed@md-and-up o-grid__cell--right u-no-p u-hidden@up-to-md">
											<button id="openTicketSymptomCheckInfo{{preVisitTicket.id}}" class="c-button c-button--tp c-button--icon--s1 u-no-pv"
															(click)="vm.openSymptomCheckInfo(preVisitTicket.id)"
															*ngIf="preVisitTicket.infermedicaInterviewId"
															title="{{ 'PreVisit.User_Tickets.Symptom_Check_Interview' | translate }}">
												<i class="o-icon o-icon--patch u-no-mr c-text c-text--lg c-text--main" style="line-height:1" aria-hidden="true"></i>
											</button>
											<button id="openTicketChat{{preVisitTicket.id}}" class="c-button c-button--tp c-button--icon--s1 u-no-pv"
											                [disabled]="preVisitTicket.patient.email.endsWith('eesti.ee')"
                                                            (click)="vm.openChat(preVisitTicket)"
                                                            title="{{ 'Wallet.Table.Action_Buttons.Chat' | translate }}">
                                                <i class="o-icon o-icon--chat u-no-mr c-text c-text--lg c-text--main" style="line-height:1" aria-hidden="true"></i>
                                            </button>
                                            <button id="openTicketInfo{{preVisitTicket.id}}" class="c-button c-button--tp c-button--icon--s1 u-no-pv"
                                                            (click)="vm.openTicketInfo(preVisitTicket)"
                                                            title="{{ 'PreVisit.User_Tickets.View_Details' | translate }}">
                                                <i class="o-icon o-icon--info u-no-mr c-text c-text--lg c-text--main" style="line-height:1" aria-hidden="true"></i>
                                            </button>
										</div>
										<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-fixed o-grid__cell--center-h u-no-p u-hidden@md-and-up">
											<button id="openTicketSymptomCheckInfo{{preVisitTicket.id}}" class="c-button c-button--tp u-no-pv o-grid--right"
															(click)="vm.openSymptomCheckInfo(preVisitTicket.id)"
															*ngIf="preVisitTicket.infermedicaInterviewId"
															title="{{ 'PreVisit.User_Tickets.Symptom_Check_Interview' | translate }}">
												<i class="o-icon o-icon--patch u-no-mr c-text c-text--lg c-text--main" style="line-height:1" aria-hidden="true"></i>
											</button>
											<button id="openTicketChat{{preVisitTicket.id}}" class="c-button c-button--tp u-no-pv o-grid--left"
											                [disabled]="preVisitTicket.patient.email.endsWith('eesti.ee')"
                                                            (click)="vm.openChat(preVisitTicket)"
                                                            title="{{ 'Wallet.Table.Action_Buttons.Chat' | translate }}">
                                                <i class="o-icon o-icon--chat u-no-mr c-text c-text--lg c-text--main" style="line-height:1" aria-hidden="true"></i>
                                            </button>
                                            <button id="openTicketInfo{{preVisitTicket.id}}" class="c-button c-button--tp u-no-pv o-grid--left"
                                                            (click)="vm.openTicketInfo(preVisitTicket)"
                                                            title="{{ 'PreVisit.User_Tickets.View_Details' | translate }}">
                                                <i class="o-icon o-icon--info u-no-mr c-text c-text--lg c-text--main" style="line-height:1" aria-hidden="true"></i>
                                            </button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</li>
				</ul>
			</div>
		</div>
		<loader-overlay *ngIf="vm.loading"></loader-overlay>
	</section>
	<p class="c-text c-text--gray c-text--center c-text--lg c-text--md@up-to-md u-ost-md@up-to-md" *ngIf="!vm.loading && !vm.preVisitTickets?.length">
		{{ 'Booking.Other.NoContent' | translate }}
	</p>
	<loader-overlay *ngIf="vm.loading"></loader-overlay>
</div>
<div class="o-grid" *ngIf="!vm.loading" [ngClass]="{'u-ost-md u-osb-md': vm.preVisitTickets?.length > vm.pageSize}">
	<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--right u-no-p">
		<list-pager [totalItems]="vm.preVisitTickets?.length" [pageSize]="vm.pageSize" [(currentPage)]="vm.currentPage" (currentPageChange)="vm.loadPreVisits()"></list-pager>
	</div>
</div>
